import { Tag, Text } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import { getPriority } from 'components/TasksV2/TasksOverview/utils'
import { isNumber } from 'lodash'
import React from 'react'

export const PriorityTag = ({ priority }: { priority?: number }) => {
  if (!isNumber(priority) || priority < 0) {
    return null
  }
  return (
    <>
      <Tag
        borderRadius="12px"
        color={getPriority(priority)?.textColor || 'black'}
        border={`1px solid ${getPriority(priority)?.textColor || 'black'}`}
        minH="unset"
        fontSize="11px"
        minW="60px"
        w="max-content"
        lineHeight="normal"
        justifyContent="center"
        alignItems="center"
        p="3px 10px"
        bg={getPriority(priority)?.bgColor || 'white'}
      >
        <Text>
          <LocaleText text={getPriority(priority)?.label || ''} />
        </Text>
      </Tag>
    </>
  )
}
